<template>
    <el-dialog title="第三方国际运费" :visible.sync="dialogTableVisible" width="40%" @close="close">
        <el-form :model="formData" ref="formData" label-width="100px" :rules="rulesFormData">
            <el-form-item label="国际运单：" prop="receiptNumber">
                <el-input placeholder="请输入" v-model="itemData.receiptNumber" :readonly="isReadonly" @blur="outConveyNumber(itemData)"></el-input>
            </el-form-item>
            <el-form-item label="渠道信息：">
                <el-col :span="12">
                    <el-form-item prop="channelName">
                        <el-input placeholder="请输入" v-model="itemData.channelName" readonly></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item prop="channelWay">
                        <el-input placeholder="请输入" v-model="itemData.channelWay" readonly></el-input>
                    </el-form-item>
                </el-col>
            </el-form-item>
            <el-form-item label="申报金额：" prop="charge">
                <el-input placeholder="请输入" v-model="formData.charge" :readonly="isReadonly">
                    <template slot="append">
                        CNY
                    </template>
                </el-input>
            </el-form-item>
            <el-form-item label="说明：" prop="description">
                <el-input
                    type="textarea"
                    :autosize="{ minRows: 4, maxRows: 4 }"
                    placeholder="请输入内容"
                    v-model="formData.description"
                    :readonly="isReadonly"
                ></el-input>
            </el-form-item>
        </el-form>
        <div class="image-list">
            <li class="list-group-item" v-for="(element, index) in formData.imageList" :key="element">
                <div class="mask">
                    <i class="custom-icon el-icon-zoom-in" @click="handlePictureCardPreview(element)"></i>
                    <i class="custom-icon el-icon-delete" v-if="!isReadonly" @click="handleRemoveSelect(index)"></i>
                </div>
                <div class="badge">
                    <img :src="element" alt />
                </div>
            </li>
            <el-upload
                v-if="!isReadonly"
                :action="action"
                list-type="picture-card"
                :on-success="handleAvatarSuccess"
                :headers="customHeaders"
                :show-file-list="false"
                multiple
            >
                <i class="el-icon-plus"></i>
            </el-upload>
            <el-dialog :visible.sync="dialogVisible" append-to-body>
                <img width="100%" :src="dialogImageUrl" alt />
            </el-dialog>
        </div>
        <div slot="footer" class="dialog-footer" v-if="!isReadonly">
            <el-button @click="dialogTableVisible = false">取 消</el-button>
            <el-button type="primary" @click="onSubmit" :loading="subloading">提 交</el-button>
        </div>
    </el-dialog>
</template>

<script>
import { ajaxPost, Baseurl } from "@/api/api/api";
export default {
    name: "Threepartyfreight",
    data() {
        return {
            action: Baseurl + "imageController/uploadImage",
            customHeaders: { token: localStorage.getItem("token") },
            dialogTableVisible: false,
            subloading:false,
            formData: {
                imageList: [],
                description: "",
                charge: "",
            },
            rulesFormData: {
                description: [{ required: true, message: "说明输入有误", trigger: "blur" }],
                charge: [{ required: true, message: "申报金额输入有误", trigger: "blur" }],
            },
            itemData: {
                receiptNumber: "",
                channelName: "",
                channelWay: "",
                orderId: "",
                amazonOrderId: ""
            },
            dialogImageUrl: "",
            dialogVisible: false,
            pageType: 'edit'
        };
    },
    computed: {
        isReadonly() {
            return this.pageType === 'edit';
        },
    },
    methods: {
        init(data, type = 'edit') {
            this.dialogTableVisible = true;
            this.subloading = false;
            this.pageType = type
            if (type === 'add')  return
            const data2 = JSON.parse(JSON.stringify(data));
            if (Object.keys(data2).length) {
                this.itemData = data2;
                let { imageList, description = "", charge = "" } = this.itemData;
                if (!imageList) imageList = [];
                if (!description) description = "";
                if (!charge) charge = "";
                this.formData = {
                    imageList,
                    description,
                    charge,
                };
                return
            }
            this.$nextTick(() => {
                this.$refs.formData.resetFields();
            });
        },
        close() {
            this.dialogTableVisible = false;
            this.formData = this.$options.data().formData
            this.itemData = this.$options.data().itemData
        },
        handleRemoveSelect(index) {
            this.formData.imageList.splice(index, 1);
        },
        handlePictureCardPreview(file) {
            this.dialogImageUrl = file;
            this.dialogVisible = true;
        },
        handleAvatarSuccess(response, file, fileList) {
            this.formData.imageList.push(response.data);
        },
        onSubmit() {
            this.subloading = true
            this.$refs.formData.validate(valid => {
                if (!valid) return;
                if (!this.formData.imageList.length) {
                    this.$message.warning("请上传图片");
                    return;
                }
                if (this.pageType === 'edit') {
                    this.formData.id = this.itemData.id;
                    this.$emit("confirm", this.formData);
                } else {
                    const data = { ...this.formData, ...this.itemData }
                    this.$emit("confirm2", data);
                }
            });
        },
        outConveyNumber(row) {
            if (!row.receiptNumber) return
            const API = Baseurl + "logisticsController/getOrderChannelByConveyNumber";
            const paramsData = {
                conveyNumber: row.receiptNumber
            };
            ajaxPost(API, paramsData).then(res => {
                const { code, data } = res.data;
                if (code === 200) {
                    row.channelName = data.channelName;
                    row.channelWay = data.channelWay
                    row.receiptId = data.id
                    row.orderId = data.orderId
                    row.amazonOrderId = data.amazonOrderId
                } else {
                    row.conveyNumber = "";
                    this.$message.error(data || '请求错误');
                }
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.line-height {
    line-height: 35px;
}
.image-list {
    display: flex;
    flex-wrap: wrap;

    .list-group-item {
        width: 148px;
        height: 148px;
        background-color: #fbfdff;
        border: 1px dashed #c0ccda;
        border-radius: 6px;
        box-sizing: border-box;
        cursor: pointer;
        margin-right: 10px;
        margin-bottom: 10px;
        // float: left;
        position: relative;
        overflow: hidden;
        .mask {
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            background: rgba(0, 0, 0, 0.5);
            position: absolute;
            top: 0;
            left: 0;
            opacity: 0;
            transition-duration: 0.5s;
            .custom-icon {
                font-size: 20px;
                margin: 0 8px;
                color: #fff;
            }
        }
        &:hover .mask {
            opacity: 1;
            border-color: #409eff;
        }
        img {
            width: 100%;
            height: 100%;
        }
    }
}
</style>
